exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":root {\n    font-size: 16px;\n}\n\n._15ok {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-pack: justify;\n        justify-content: space-between;\n    margin-bottom: 1em;\n}\n\n/* on mobile or if no CSS grid support use single column view */\n\n._15a_ {\n    margin-bottom: 20px;\n}\n\n._41rf {\n    text-align: center;\n}\n\n.T5Dj {\n    display: -ms-grid;\n    display: grid;\n    -ms-grid-columns: 1fr;\n        grid-template-columns: 1fr;\n    grid-gap: 12px;\n    margin-bottom: 8px\n}\n\n@media (min-width: 768px) {\n\n.T5Dj {\n        -ms-grid-columns: 1fr 1fr;\n            grid-template-columns: 1fr 1fr\n}\n    }\n", ""]);

// exports
exports.locals = {
	"title": "_15ok",
	"list": "_15a_",
	"informationText": "_41rf",
	"buddiesCardsContainer": "T5Dj"
};